import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        backgroundColor: Theme.primaryBackgroundColor
    },
    innerContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: Theme.primaryMargin + 10
    },
    header: {
        position: 'relative',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
        marginTop: 30,
        width: '100%'
    },
    headerHeading: {
        fontSize: Theme.primaryFontSize,
        color: Theme.lightThemeTextColor
    },
    headerCloseIcon: {
        position: 'absolute',
        right: 8,
        top: 10,
        width: 31,
        height: 31
    },
    filterItem: {
        width: '100%',
        paddingHorizontal: Theme.primaryMargin
    },
    filterItemLabel: {
        lineHeight: 50,
        fontSize: Theme.primaryFontSize,
        color: Theme.lightThemeTextColor
    },
    filterItemLabelSelected: {
        color: Theme.primaryLinkColor
    }
};

export default StyleSheet.create(baseStyles);
